module.exports = __webpack_public_path__ + "assets/dropdown.ad7969d5.svg";